const MONTHLY_INSTALLMENT = 'MONTHLY_INSTALLMENT'
const UPFRONT_PAYMENT = 'UPFRONT_PAYMENT'

const programForm = [
  {
    id: "siteId",
    label: "Site Id",
    name: "siteId",
    type: "numeric",
  },
  {
    id: "customerFirstName",
    label: "Customer First Name",
    name: "customerFirstName",
    type: "textField",
  },
  {
    id: "customerLastName",
    label: "Customer Last Name",
    name: "customerLastName",
    type: "textField",
  },
  {
    id: "address1",
    label: "Address Line 1",
    name: "address1",
    type: "textField",
  },
  {
    id: "address2",
    label: "Address Line 2",
    name: "address2",
    type: "textField",
  },
  {
    id: "city",
    label: "City",
    name: "city",
    type: "textField"
  },
  {
    id: "state",
    label: "State",
    name: "state",
    type: "textField"
  },
  {
    id: "zip",
    label: "Zip Code",
    name: "zip",
    type: "numeric"
  },
  {
    id: "ean",
    label: "Electric Account Number",
    name: 'ean',
    type: "numeric"
  },
  {
    id: "paymentOptionType",
    label: "Program Payment Option Type",
    name: 'paymentOptionType',
    type: "select",
    dropdownOptions: [
      {
        label: 'Monthly Installment',
        value: MONTHLY_INSTALLMENT,
      },
      {
        label: 'One time Payment',
        value: UPFRONT_PAYMENT,
      }
    ]
  },
  {
    id: "premiseId",
    label: "Optional Id",
    name: "premiseId",
    type: "textField",
  },
  {
    id: "file",
    name: "file",
    type: "file",
  }
]

export {
  programForm,
  MONTHLY_INSTALLMENT,
  UPFRONT_PAYMENT
}